var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.user.components.includes(81))?_c('v-container',[_c('v-card',[_c('v-card-text',[_c('crud',{attrs:{"model":"Diagnosis","headers":_vm.headers,"label":"ICD10 Diagnoses Codes"}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }